import callApiAxiosClient from "../../axios/axios_client";
import moment from "moment";
import { lfProductAvailabilityList } from "../../models";


async function lfProductAvailability(locationId: number, date: Date | undefined, fromHour: number, toHour: number): Promise<lfProductAvailabilityList> {
    const token = JSON.parse(localStorage.getItem('user')!)
    const dateParam = moment(date).format("YYYYMMDD");
    const authorization = 'Bearer ' + token.token
    return callApiAxiosClient<lfProductAvailabilityList>({
        method: "get",
        url: "programmability/availability",
        headers: {
            "Content-Type": "Application/json",
            "Authorization": authorization

        },
        params: {
            locationId: locationId,
            date: dateParam,
            fromHour: fromHour,
            toHour: toHour,
        }
    })
}
export default lfProductAvailability;